export const environment = {
  id: "dev",
  production: false,
  API_V3: "https://api.prod.venues.socashless.com",
  FIREBASE: {
    apiKey: "to_be_updated",
    authDomain: "to_be_updated",
    databaseURL: "to_be_updated",
    projectId: "to_be_updated",
    storageBucket: "to_be_updated",
    messagingSenderId: "to_be_updated",
    appId: "to_be_updated",
    measurementId: "to_be_updated",
  },
  MIXPANEL_TOKEN: "to_be_updated",
  FEATURE_FLAG: {
    clientSideID: "to_be_updated",
  },
  SENTRY_DSN: "https://to_be_updated.ingest.sentry.io/to_be_updated",
  ACTIVE_MQ_HOST: "wss:mq.prod.venues.socashless.com/",
  ACTIVE_MQ_USER: "socashless_prod",
  ACTIVE_MQ_PW: "R@nd0mp4ssw0Rd",
  SOCASHLESS_VENUES: "https://socashless.dev.socashless.globaldev.asia/",
  SOCASHLESS_ACCOUNTS: "https://dashboard.venues.socashless.com/",
  PABBLY_SUBSCRIPTION_WITH_FREE_TRIAL: "https://to_be_updated",
  PABBLY_SUBSCRIPTION_WITHOUT_FREE_TRIAL: "https://to_be_updated",
  MEWS_URL: "https://www.mews.li/Commander/Home/SignIn",
  CONNECTOR_URL: "https://dashboard.venues.socashless.com/",
  CLOUDBEDS_CONNECT_URL: "https://to_be_updated",
  FORGOT_PASSWORD_URL: "https://dashboard.venues.socashless.com/",
  BOOKING_DATA_TEMPLATE_URL: "https://s3_to_be_updated/import+tickets+template.xlsx",
};
